"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const Utilities_1 = require("../utilities/Utilities");
const AdditionalColumnHeader_1 = __importDefault(require("./AdditionalColumnHeader"));
const CorrelationTableRow_1 = __importDefault(require("./CorrelationTableRow"));
const tableStyle = (0, react_1.css) `
  overflow: auto;
  height: 100%;
  display: block;

  table {
    border-spacing: 0;
    border: 1px solid #dedede;
    width: 100%;
    font-size: 12px;
    height: 100%;
  }

  th {
    position: sticky;
    background-color: white;
    top: 0;
  }

  th,
  td {
    white-space: nowrap;
    text-align: center;
    margin: 0;
    padding: 0.4rem;
    border-bottom: 1px solid #dedede;
    border-right: 1px solid #dedede;

    :last-child {
      border-right: 0;
    }

    button {
      background-color: transparent;
      border: none;
    }
  }

  tr {
    :last-child {
      td {
        border-bottom: 0;
      }
    }
  }

  thead tr {
    background-color: white !important;
  }
`;
function CorrelationTable({ correlationsData, filteredCorrelationsData, additionalColumnData, editEquivalencesSaveHandler, onSaveEditNumericValues, onEditCorrelationTableCellHandler, showProtonsAsRows, spectraData, }) {
    const rows = (0, react_2.useMemo)(() => {
        if (!filteredCorrelationsData) {
            return [];
        }
        return filteredCorrelationsData.values
            .filter((correlation) => showProtonsAsRows
            ? correlation.atomType === 'H'
            : correlation.atomType !== 'H')
            .map((correlation) => ((0, jsx_runtime_1.jsx)(CorrelationTableRow_1.default, { additionalColumnData: additionalColumnData, correlations: correlationsData.values, correlation: correlation, styleRow: { backgroundColor: 'mintcream' }, styleLabel: correlation.atomType === 'H'
                ? {
                    color: (0, Utilities_1.getLabelColor)(correlationsData, correlation),
                }
                : {}, onSaveEditEquivalences: editEquivalencesSaveHandler, onSaveEditNumericValues: onSaveEditNumericValues, onEditCorrelationTableCellHandler: onEditCorrelationTableCellHandler, spectraData: spectraData }, `correlation${correlation.atomType}${correlation.id}`)));
    }, [
        filteredCorrelationsData,
        showProtonsAsRows,
        additionalColumnData,
        correlationsData,
        editEquivalencesSaveHandler,
        onSaveEditNumericValues,
        onEditCorrelationTableCellHandler,
        spectraData,
    ]);
    const additionalColumnHeader = (0, react_2.useMemo)(() => additionalColumnData.map((correlation) => ((0, jsx_runtime_1.jsx)(AdditionalColumnHeader_1.default, { spectraData: spectraData, correlationsData: correlationsData, correlation: correlation, onEdit: onEditCorrelationTableCellHandler }, `additionalCorrelationHeader_${correlation.id}`))), [
        additionalColumnData,
        correlationsData,
        onEditCorrelationTableCellHandler,
        spectraData,
    ]);
    return ((0, jsx_runtime_1.jsx)("div", { css: tableStyle, children: (0, jsx_runtime_1.jsxs)("table", { children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("th", { children: "Atom" }), (0, jsx_runtime_1.jsx)("th", { children: "\u03B4 (ppm)" }), (0, jsx_runtime_1.jsx)("th", { children: "Equiv" }), (0, jsx_runtime_1.jsx)("th", { children: "#H" }), (0, jsx_runtime_1.jsx)("th", { style: { borderRight: '1px solid' }, children: "Hybrid" }), additionalColumnHeader] }) }), (0, jsx_runtime_1.jsx)("tbody", { children: rows })] }) }));
}
exports.default = CorrelationTable;
